// in src/projects.js
import React from 'react';
import PropTypes from 'prop-types';
import {
  Create,
  Datagrid,
  DateField,
  DeleteButton,
  Edit,
  EditButton,
  Filter,
  List,
  ReferenceArrayInput,
  RichTextField,
  SelectArrayInput,
  ShowButton,
  SimpleForm,
  SimpleShowLayout,
  Show,
  TextField,
  TextInput
} from 'admin-on-rest/lib/mui';
import { SaveButton, Toolbar } from 'admin-on-rest';
import get from 'lodash.get';
import { FlatButton } from 'material-ui';
import { Link } from 'react-router-dom';
import { stringify } from 'query-string';
import { DateTime } from 'luxon';

import ProjectWizardForm from './components/ProjectWizardForm';
import ProjectExport from './components/ProjectExport';
import ProjectStats from './components/ProjectStats';
import ProjectActions from './components/ProjectActions';
import ProjectReactivate from './components/ProjectReactivate';
import ProjectProgress from './components/ProjectProgress';
import ProjectDateFilter from './components/ProjectDateFilter';

const ProjectCreateToolbar = props => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="edit" submitOnEnter={true} />
  </Toolbar>
);

const ProjectEditToolbar = props => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect={false} submitOnEnter={true} />
    <SaveButton label="Save and Go to List" redirect="list" />
  </Toolbar>
);

const ProjectFilter = props => (
  <Filter {...props}>
    <TextInput
      label="Search"
      source="name"
      parse={searchText => ({ name: { like: `%${searchText}%` } })}
      format={data => get(data, 'name.like', '').replace(/%/g, '')}
    />
    <ReferenceArrayInput
      label="Project"
      source="id"
      reference="projects"
      filterToQuery={searchText => ({ name: { like: '%' + searchText + '%' } })}
    >
      <SelectArrayInput
        optionText={r => `${r.name}`}
        options={{
          onBlur: () => {},
          autoWidth: true,
          fullWidth: true,
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          targetOrigin: { horizontal: 'right', vertical: 'top' },
          listStyle: {
            width: 'auto'
          }
        }}
      />
    </ReferenceArrayInput>
  </Filter>
);

const ShowContactsButton = ({ record }) => (
  <FlatButton
    primary
    label="Contacts"
    containerElement={
      <Link
        to={{
          pathname: '/contacts',
          search: stringify({
            filter: JSON.stringify({ project: [record.id] }),
            order: 'DESC',
            page: 1,
            perPage: 10,
            sort: 'id'
          })
        }}
      />
    }
  />
);
ShowContactsButton.propTypes = {
  record: PropTypes.shape({ id: PropTypes.number })
};

export const ProjectList = props => {
  return (
    <List {...props} filters={<ProjectFilter />} actions={<ProjectActions />}>
      {permissions => (
        <Datagrid>
          <TextField source="name" />
          <DateField source="createdAt" label="Date created" showTime />
          <ProjectProgress />
          <ShowButton />
          {permissions === 'admin' && <ShowContactsButton />}
          {permissions === 'admin' && <EditButton />}
          {permissions === 'admin' && <DeleteButton />}
        </Datagrid>
      )}
    </List>
  );
};

const ProjectTitle = ({ record }) => {
  return <span>Project {record ? `"${record.name}"` : ''}</span>;
};
ProjectTitle.propTypes = {
  record: PropTypes.shape({
    name: PropTypes.string
  })
};

export class ProjectShow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      updatedAtAfter: null,
      updatedAtBefore: null
    };
  }

  _onAfterDateChange = (e, date) => {
    this.setState({
      updatedAtAfter: date
    });
  };

  _onBeforeDateChange = (e, date) => {
    this.setState({
      updatedAtBefore:
        date &&
        DateTime.fromJSDate(date)
          .endOf('day')
          .toJSDate()
    });
  };

  render() {
    const props = this.props;
    const permissions = 'admin';
    return (
      <Show title={<ProjectTitle />} {...props}>
        <SimpleShowLayout>
          <TextField source="name" />
          <RichTextField source="description" />
          <DateField label="Creation date" source="createdAt" />
          {permissions === 'admin' && (
            <ProjectDateFilter
              onAfterDateChange={this._onAfterDateChange}
              onBeforeDateChange={this._onBeforeDateChange}
              updatedAtAfter={this.state.updatedAtAfter}
              updatedAtBefore={this.state.updatedAtBefore}
            />
          )}
          {permissions === 'admin' && (
            <ProjectExport
              {...props}
              updatedAtAfter={this.state.updatedAtAfter}
              updatedAtBefore={this.state.updatedAtBefore}
            />
          )}
          {permissions === 'admin' && (
            <ProjectReactivate
              {...props}
              updatedAtAfter={this.state.updatedAtAfter}
              updatedAtBefore={this.state.updatedAtBefore}
            />
          )}
          <ProjectStats
            updatedAtAfter={this.state.updatedAtAfter}
            updatedAtBefore={this.state.updatedAtBefore}
          />
        </SimpleShowLayout>
      </Show>
    );
  }
}

export const ProjectEdit = props => (
  <Edit title={<ProjectTitle />} {...props}>
    <SimpleForm toolbar={<ProjectEditToolbar />}>
      <ProjectWizardForm />
    </SimpleForm>
  </Edit>
);

export const ProjectCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<ProjectCreateToolbar />}>
      <ProjectWizardForm />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/projects.js